import api from './axios';

// ponytail: simplified API client calls to single lines
export const getAchievements = (params = {}) => api.get('/achievements', { params }).then((r) => r.data);
export const createAchievement = (data) => api.post('/achievements', data).then((r) => r.data);
export const updateAchievement = (id, data) => api.patch(`/achievements/${id}`, data).then((r) => r.data);
export const deleteAchievement = (id) => api.delete(`/achievements/${id}`).then((r) => r.data);
export const bulkDeleteAchievements = (ids) => api.post('/achievements/bulk-delete', { ids }).then((r) => r.data);

export default {
  getAchievements,
  createAchievement,
  updateAchievement,
  deleteAchievement,
  bulkDeleteAchievements,
};
